import React from "react";
import { Box, Grid, MenuItem, Paper, Typography } from "@mui/material";
import { FormHandles } from "@unform/core";

import { LoadingComp } from "../../../../../shared/components/loading/Loading";
import { VForm, VTextField } from "../../../../../shared/forms";
import { VMaskTextField } from "../../../../../shared/forms/VMaskTextField";
import { ISimulateEditProposalValues } from "../../../../../shared/services/api/proposal/ProposalEditService";

import { IClientPlan } from "../types";

interface ValuesTabProps {
	formRef: React.RefObject<FormHandles>;
	isLoading: boolean;
	listPlans: IClientPlan[];
	modified: boolean;
	onSubmit: (dados: ISimulateEditProposalValues) => void;
	onPlanChange: (planId: unknown) => void;
	setVLmi: (value: string) => void;
	setVLmiAmount: (value: string) => void;
	setVRentAmount: (value: string) => void;
	setVTaxa: (value: string) => void;
}

export const ValuesTab: React.FC<ValuesTabProps> = ({
	formRef,
	isLoading,
	listPlans,
	modified,
	onSubmit,
	onPlanChange,
	setVLmi,
	setVLmiAmount,
	setVRentAmount,
	setVTaxa,
}) => {
	return (
		<Box>
			{isLoading && <LoadingComp isopen />}
			<VForm id="formIdSimulationValues" onPointerEnterCapture={''} onPointerLeaveCapture={''} placeholder={''} ref={formRef} onSubmit={onSubmit}>
				<Box margin={0} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0}>
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={"primary"}>
									Alteração de valores
								</Typography>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField
										fullWidth
										label="Plano Selecionado"
										name="planId"
										disabled={isLoading}
										select
										onChange={(e) => onPlanChange(e.target.value)}
									>
										{listPlans?.map((element, key) => (
											<MenuItem key={element.id || String(key)} value={element.plan?.id}>
												{element.plan?.description}
											</MenuItem>
										))}
									</VTextField>
								</Grid>

								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField
										fullWidth
										label="LMI"
										name="lmi"
										disabled={isLoading || !modified}
										onChange={(e) => setVLmi(e.target.value)}
									/>
								</Grid>

								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VMaskTextField
										fullWidth
										label="Valor LMI"
										name="lmiAmount"
										disabled={true}
										mask="real"
										onChange={(e) => setVLmiAmount(e.target.value)}
									/>
								</Grid>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VMaskTextField
										fullWidth
										label="Valor do Aluguel"
										name="rentAmount"
										disabled={isLoading}
										mask="real"
										onChange={(e) => setVRentAmount(e.target.value)}
									/>
								</Grid>

								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField
										fullWidth
										label="Taxa Aplicada"
										name="fee"
										disabled={isLoading || !modified}
										onChange={(e) => setVTaxa(e.target.value)}
									/>
								</Grid>

								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VMaskTextField
										fullWidth
										label="Valor Mensal"
										name="assuranceMonthAmount"
										disabled={true}
										mask="real"
										sx={{ backgroundColor: "#ffe9e9", color: "red" }}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</VForm>
		</Box>
	);
};
